var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","overflow":"hiddle"}},[_c('iframe',{attrs:{"src":_vm.iframeUrl,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }